import CloseIcon from '@mui/icons-material/Close';
import { generateMqttClient } from '@pages/_loader/initMqttClient.loader';
import { MqttClient } from 'mqtt';
import React, { useEffect } from 'react';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  styled,
} from '@mui/material';
import PowinBessDetails from '@components/Battery/Powin/PowinBessDetails';
import PowinBessRackList from './PowinBessRackList';

const StyledDialogTitle = styled(DialogTitle)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

interface Props {
  selectedBessId: string;
  bessName: string | undefined;
  open: boolean;
  powinControllerName: string;
  onClose: () => void;
}

function PowinBessDetailsModal(props: Props) {
  const { selectedBessId, open } = props;
  const [mqttClient, setMqttClient] = React.useState<MqttClient | undefined>(
    undefined,
  );

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    if (!open) {
      return () => {};
    }
    const startClient = async () => {
      const client = await generateMqttClient();
      setMqttClient(client);
    };
    startClient();
    return () => mqttClient?.end();
  }, [open]);

  const onClose = () => {
    props.onClose();
    mqttClient?.end();
  };

  return (
    <Dialog onClose={onClose} open={open} maxWidth='md' fullWidth>
      <StyledDialogTitle>
        {props.powinControllerName} {props.bessName} Details
        <IconButton onClick={onClose} sx={{ mr: -2, mt: -1 }}>
          <CloseIcon />
        </IconButton>
      </StyledDialogTitle>
      <DialogContent dividers>
        <Box sx={{ mt: 1, mb: 5 }}>
          {open ? (
            <>
              <PowinBessDetails
                selectedBessId={selectedBessId}
                useNewClient={mqttClient}
              />
              <PowinBessRackList selectedBessId={selectedBessId} />
            </>
          ) : null}
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default PowinBessDetailsModal;
